import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { getBundleAvailability } from 'store/ProductDetails/bundles/selectors';
import { getPreorderOnlyBasket } from 'store/ProductDetails/preorder/selectors';

import ViewLayout from '../_ViewLayout';
import { FlocktoryProductContainer } from '../../components';
import BundleContainer from '../../components/BundleContainer';
import SchemaProductContainer from '../../components/SchemaProductContainer';

/**
 * ProductDetails view for preorder, extends page ViewLayout
 * adding preorder mechanics and form
 */
const PreorderView = ({ hasAvailableBundles, onlyBasket }) => {
  return (
    <SchemaProductContainer>
      <FlocktoryProductContainer>
        <ViewLayout
          detailsType="preOrder"
          extraChildren={hasAvailableBundles && onlyBasket ? <BundleContainer /> : null}
        />
      </FlocktoryProductContainer>
    </SchemaProductContainer>
  );
};

PreorderView.propTypes = {
  hasAvailableBundles: PropTypes.bool,
  /** display type props */
  onlyBasket: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  hasAvailableBundles: getBundleAvailability(state),
  onlyBasket: getPreorderOnlyBasket(state),
});

export default connect(mapStateToProps)(PreorderView);
